"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { FiImage } from "react-icons/fi";
import Image from "next/image";
import { reportScribeAttachmentLoaded } from "@/lib/scribe-attachment-analytics";
import { cx } from "@/lib/tailwind-utils";
interface AttachmentPreviewImageProps {
  thumbnailSignedUrl?: string | null;
  signedUrl?: string | null;
  alt: string;
  iconClassName?: string;
  /** Width / height of the image that actually loaded, for overlays sized against it. */
  onAspectRatio?: (aspectRatio: number) => void;
}

/**
 * Gallery tile image that prefers the thumbnail and falls back to the full
 * image once if the thumbnail fails to load. Not every attachment has a
 * generated thumb_*.jpg, so a thumbnail URL is no promise the file exists.
 */
export function AttachmentPreviewImage(t0) {
  const $ = _c(15);
  const {
    thumbnailSignedUrl,
    signedUrl,
    alt,
    iconClassName,
    onAspectRatio
  } = t0;
  const [failedThumbnailUrl, setFailedThumbnailUrl] = useState(null);
  const usingThumbnail = !!thumbnailSignedUrl && thumbnailSignedUrl !== failedThumbnailUrl;
  const src = usingThumbnail ? thumbnailSignedUrl : signedUrl;
  if (!src) {
    let t1;
    if ($[0] !== iconClassName) {
      t1 = cx("text-foreground-muted", iconClassName);
      $[0] = iconClassName;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <div className="flex h-full w-full items-center justify-center"><FiImage className={t1} /></div>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t1;
  if ($[4] !== onAspectRatio || $[5] !== usingThumbnail) {
    t1 = e => {
      reportScribeAttachmentLoaded(usingThumbnail);
      const {
        naturalWidth,
        naturalHeight
      } = e.currentTarget;
      if (onAspectRatio && naturalWidth && naturalHeight) {
        onAspectRatio(naturalWidth / naturalHeight);
      }
    };
    $[4] = onAspectRatio;
    $[5] = usingThumbnail;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== thumbnailSignedUrl || $[8] !== usingThumbnail) {
    t2 = () => {
      if (usingThumbnail) {
        setFailedThumbnailUrl(thumbnailSignedUrl);
      }
    };
    $[7] = thumbnailSignedUrl;
    $[8] = usingThumbnail;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== alt || $[11] !== src || $[12] !== t1 || $[13] !== t2) {
    t3 = <Image key={src} src={src} alt={alt} fill={true} className="object-cover" unoptimized={true} onLoad={t1} onError={t2} />;
    $[10] = alt;
    $[11] = src;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}